module.exports = __webpack_public_path__ + "media/images/mobile/abouts/9-88f30fd34ca4580f56dd91f039e35459.jpg";